import React, { useState } from 'react';
// Modal
import ReservationFormModal from '../../../layouts/Modals/ReservationFormModal';

const ReservationCreate = () => {
  const [ show, setShow ] = useState(false);
  return (
    <>
      <div className="form-group text-right">
        <button
          className="btn btn-primary btn-sm"
          type="button"
          onClick={() => setShow(true)}
        >Create reservation</button>
      </div>
      {/* Modal */}
      {show &&
        <ReservationFormModal
          show={show}
          onHide={() => setShow(false)}
        />
      }
    </>
  )
}

export default ReservationCreate;
